module.exports = {"542425100":"扎仁镇","542425101":"雁石坪镇","542425102":"强玛镇","542425103":"帕那镇","542425200":"措玛乡","542425201":"滩堆乡","542425202":"扎曲乡","542425203":"岗尼乡","542425204":"玛曲乡","542425205":"色务乡","542425206":"玛荣乡","542425207":"多玛乡","542425208":"帮爱乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542425.json
// module id = 2555
// module chunks = 0